var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-writer.ts
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-formfield-wrapper.js";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { XPlainWriter } from "./x-plain-writer.js";
var XWriter = class extends XPlainWriter {
  constructor() {
    super(...arguments);
    this.minheight = "";
  }
  get inputToken() {
    return inputToken(this);
  }
  get _showLabel() {
    return this.placeholder && this.value.value !== void 0 && this.value.value !== null && this.value.value !== "" || !!this.error;
  }
  render() {
    return xComponents(html`
      <div id="toolbarContainer"></div>
      <x-formfield-wrapper
        multi-line
        ${injectAttributesOf(this, ["tabindex"])}
        ?show-label=${this._showLabel}
        @click=${() => !this.disabled && !this._focused && this.selectAll(true)}
        @cleared=${() => {
      this.value.next("");
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: "" } }));
    }}
      >
        <x-flex
          flex
          ${css({
      width: "100%",
      height: "100%",
      ...this.minheight ? { minHeight: this.minheight, maxHeight: "200px", overflow: "auto" } : {},
      justifyContent: "unset",
      flexDirection: "column"
    })}
        >
          <x-flex horizontal flex space="sm"> ${super.render()} </x-flex>
        </x-flex>
      </x-formfield-wrapper>
    `);
  }
  toolbarContainer() {
    return nothing;
  }
};
__decorateClass([
  property()
], XWriter.prototype, "minheight", 2);
XWriter = __decorateClass([
  customElement("x-writer")
], XWriter);
export {
  XWriter
};
